module.exports = __webpack_public_path__ + "static/colors-in-italian-2819d-3fd6b5f9417eb239f7994b441532c7d9.jpg";